import { jsxs as m, jsx as i } from "react/jsx-runtime";
import { forwardRef as x, useState as N } from "react";
import { Button as c } from "../Button/index.js";
import { AngleDownFarFAIcon as r } from "../Icons/index.js";
import { T as o } from "../../Text-B7Ta53Id.js";
import { F } from "../../Flex-BcSdq2bJ.js";
import '../../assets/index11.css';const B = "Timeline-module__timelineContainer___SOQVc", v = "Timeline-module__timelineTitle___IeGRw", D = "Timeline-module__timelineWrapper___TKA9F", g = "Timeline-module__timelineItem___AKgIc", w = "Timeline-module__timelineDate___NFcw9", I = "Timeline-module__timelineConnector___8fGms", W = "Timeline-module__timelineContent___zZdfC", E = "Timeline-module__timelineDot___gwiac", S = "Timeline-module__timelineBullet___j8Ws9", A = "Timeline-module__timelineFaded___9r3WH", $ = "Timeline-module__timelineExpandButton___FQl4W", e = {
  timelineContainer: B,
  timelineTitle: v,
  timelineWrapper: D,
  timelineItem: g,
  timelineDate: w,
  timelineConnector: I,
  timelineContent: W,
  timelineDot: E,
  timelineBullet: S,
  timelineFaded: A,
  timelineExpandButton: $
}, j = x(({
  "data-plum-id": u,
  title: a,
  items: n,
  initialVisibleItems: d = n.length,
  expandable: s = !1,
  className: p
}, T) => {
  const [t, _] = N(!1), f = t ? n : n.slice(0, d), C = n.length - d;
  return /* @__PURE__ */ m("div", { className: `${e.timelineContainer} ${p || ""}`, ref: T, "data-plum-id": u, children: [
    a && /* @__PURE__ */ i(o, { fw: 500, size: "lg", className: e.timelineTitle, children: a }),
    /* @__PURE__ */ m("div", { className: e.timelineWrapper, children: [
      f.map((l, h) => /* @__PURE__ */ m(F, { className: e.timelineItem, children: [
        /* @__PURE__ */ i(o, { className: e.timelineDate, children: l.date || "" }),
        /* @__PURE__ */ i("div", { className: e.timelineConnector, children: l.bullet ? /* @__PURE__ */ i("div", { className: e.timelineBullet, children: l.bullet }) : /* @__PURE__ */ i("div", { className: e.timelineDot }) }),
        /* @__PURE__ */ i(o, { className: `${e.timelineContent} ${l.faded ? e.timelineFaded : ""}`, children: l.content })
      ] }, h)),
      s && C > 0 && !t && /* @__PURE__ */ m(
        c,
        {
          variant: "tertiary",
          leftSection: /* @__PURE__ */ i(r, {}),
          className: e.timelineExpandButton,
          onClick: () => _(!0),
          "data-expanded": t,
          children: [
            "Open all",
            " ",
            n.length,
            " ",
            "events"
          ]
        }
      ),
      s && t && /* @__PURE__ */ i(
        c,
        {
          variant: "tertiary",
          leftSection: /* @__PURE__ */ i(r, {}),
          className: e.timelineExpandButton,
          onClick: () => _(!1),
          "data-expanded": t,
          children: "Show less"
        }
      )
    ] })
  ] });
});
j.displayName = "Timeline";
export {
  j as Timeline
};
